<template>
  <div class="dimension-page">
    <div class="page-head">
      <div class="page-title">全维度运输查询</div>
      <div class="page-actions">
        <el-button size="small" icon="el-icon-refresh" @click="resetFilters">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-search" :loading="searching" @click="handleSearch">
          查询
        </el-button>
      </div>
    </div>

    <div class="section">
      <el-form :model="filters" label-width="96px" size="small">
        <el-row :gutter="12">
          <el-col :xs="24" :sm="12" :md="5">
            <el-form-item label="统计时间">
              <el-select v-model="filters.timeType" style="width: 100%">
                <el-option v-for="item in timeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="9">
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="filters.timeRange"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="5">
            <el-form-item label="客户">
              <el-select
                v-model="filters.custNo"
                clearable
                filterable
                placeholder="请选择客户"
                :filter-method="filterCustomers"
                :loading="customerLoading"
                style="width: 100%"
              >
                <el-option v-for="item in customerOptions" :key="item.id" :label="item.deptName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="5">
            <el-form-item label="煤种">
              <el-select
                v-model="filters.cargoNo"
                clearable
                filterable
                placeholder="请选择煤种"
                :filter-method="filterCargoes"
                :loading="cargoLoading"
                style="width: 100%"
              >
                <el-option v-for="item in cargoOptions" :key="item.varNo" :label="item.varName" :value="item.varNo" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :xs="24" :sm="12" :md="5">
            <el-form-item label="计划号">
              <el-input v-model.trim="filters.planNo" clearable placeholder="计划号" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="5">
            <el-form-item label="车号">
              <el-input v-model.trim="filters.trainNumber" clearable placeholder="车牌/车号" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="5">
            <el-form-item label="车辆节点">
              <el-select v-model="filters.stageCode" clearable placeholder="车辆节点" style="width: 100%">
                <el-option v-for="item in stageOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="5">
            <el-form-item label="车辆状态">
              <el-select v-model="filters.vehicleStatus" clearable placeholder="车辆状态" style="width: 100%">
                <el-option label="未开始" :value="0" />
                <el-option label="进行中" :value="1" />
                <el-option label="已完成" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="4" class="more-filter">
            <el-button size="small" @click="showMoreFilters = !showMoreFilters">
              更多筛选
            </el-button>
          </el-col>
        </el-row>

        <el-collapse-transition>
          <el-row v-show="showMoreFilters" :gutter="12">
            <el-col :xs="24" :sm="12" :md="5">
              <el-form-item label="司机">
                <el-input v-model.trim="filters.driverName" clearable placeholder="司机" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="5">
              <el-form-item label="手机号">
                <el-input v-model.trim="filters.phoneNo" clearable placeholder="手机号" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="5">
              <el-form-item label="仓库">
                <el-input v-model.trim="filters.stockCode" clearable placeholder="仓库编码" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="5">
              <el-form-item label="库位">
                <el-input v-model.trim="filters.locationCode" clearable placeholder="库位编码" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-transition>
      </el-form>
    </div>

    <el-row :gutter="12" class="summary-row">
      <el-col v-for="item in summaryCards" :key="item.key" :xs="12" :sm="8" :md="4">
        <div class="metric" :class="{ 'metric--warning': item.warning }">
          <div class="metric__label">{{ item.label }}</div>
          <div class="metric__value">{{ item.value }}</div>
          <div class="metric__unit">{{ item.unit }}</div>
        </div>
      </el-col>
    </el-row>

    <div class="section">
      <div class="section__head">
        <span>车辆节点</span>
      </div>
      <div v-loading="stageLoading" class="stage-grid">
        <div
          v-for="item in stageCards"
          :key="item.key"
          class="stage-card"
          :class="{ 'stage-card--active': filters.stageCode === item.key }"
          @click="handleStageClick(item.key)"
        >
          <div class="stage-card__top">
            <span>{{ item.label }}</span>
            <strong>{{ item.count }}</strong>
          </div>
          <div class="stage-card__bar">
            <span :style="{ width: item.percent + '%' }" />
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section__head">
        <span>分组复盘</span>
        <el-radio-group v-model="activeDimension" size="small" @change="handleDimensionChange">
          <el-radio-button v-for="item in dimensionTabs" :key="item.value" :label="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <el-table v-loading="groupLoading" :data="groupRecords" border stripe height="260" empty-text="暂无数据">
        <el-table-column prop="groupName" label="分组" min-width="180" show-overflow-tooltip />
        <el-table-column label="实际出库量(吨)" width="140" align="right">
          <template slot-scope="{ row }">{{ formatWeight(row.totalNetWeight) }}</template>
        </el-table-column>
        <el-table-column prop="truckCount" label="车次" width="90" align="right" />
        <el-table-column prop="inProgressTruckCount" label="进行中" width="90" align="right" />
        <el-table-column label="平均在厂(分钟)" width="130" align="right">
          <template slot-scope="{ row }">{{ formatNumber(row.avgPlantStayMinutes) }}</template>
        </el-table-column>
        <el-table-column
          v-if="activeDimension === 'plan'"
          label="计划量(吨)"
          width="120"
          align="right"
        >
          <template slot-scope="{ row }">{{ formatWeight(row.planTotalWeight) }}</template>
        </el-table-column>
        <el-table-column
          v-if="activeDimension === 'plan'"
          label="完成率"
          width="100"
          align="right"
        >
          <template slot-scope="{ row }">{{ formatRate(row.planCompleteRate) }}</template>
        </el-table-column>
      </el-table>
    </div>

    <div class="section">
      <div class="section__head">
        <span>车辆明细</span>
      </div>
      <el-table v-loading="tableLoading" :data="tableRecords" border stripe empty-text="暂无数据">
        <el-table-column prop="planNo" label="计划号" width="150" show-overflow-tooltip />
        <el-table-column prop="custName" label="客户" min-width="150" show-overflow-tooltip />
        <el-table-column prop="cargoName" label="煤种" width="120" show-overflow-tooltip />
        <el-table-column label="仓库/库位" min-width="160" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ formatStockLocation(row) }}</template>
        </el-table-column>
        <el-table-column prop="trainNumber" label="车号" width="120" show-overflow-tooltip />
        <el-table-column label="当前节点" width="110">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="getStageTagType(row)">{{ getRowStageName(row) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ingateTime" label="进门" width="150" />
        <el-table-column prop="emptyTime" label="空磅" width="150" />
        <el-table-column prop="heavyTime" label="重磅" width="150" />
        <el-table-column prop="outgateTime" label="出门" width="150" />
        <el-table-column label="净重(吨)" width="110" align="right">
          <template slot-scope="{ row }">{{ formatWeight(row.netWeight || row.weight) }}</template>
        </el-table-column>
        <el-table-column label="在厂时长" width="110" align="right">
          <template slot-scope="{ row }">{{ formatStay(row) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="page.currentPage"
        :page-size="page.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="page.total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-drawer
      title="车辆详情"
      :visible.sync="detailVisible"
      size="520px"
      append-to-body
      custom-class="dimension-detail"
    >
      <div v-loading="detailLoading" class="detail-body">
        <el-descriptions v-if="detailRecord" :column="2" border size="small">
          <el-descriptions-item label="车号">{{ detailRecord.trainNumber || "-" }}</el-descriptions-item>
          <el-descriptions-item label="当前节点">{{ getRowStageName(detailRecord) }}</el-descriptions-item>
          <el-descriptions-item label="客户">{{ detailRecord.custName || "-" }}</el-descriptions-item>
          <el-descriptions-item label="煤种">{{ detailRecord.cargoName || "-" }}</el-descriptions-item>
          <el-descriptions-item label="仓库/库位">{{ formatStockLocation(detailRecord) }}</el-descriptions-item>
          <el-descriptions-item label="净重">{{ formatWeight(detailRecord.netWeight || detailRecord.weight) }} 吨</el-descriptions-item>
          <el-descriptions-item label="司机">{{ detailRecord.driverName || "-" }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ detailRecord.phoneNoMasked || "-" }}</el-descriptions-item>
        </el-descriptions>
        <el-timeline v-if="detailRecord" class="detail-timeline">
          <el-timeline-item timestamp="进门">{{ detailRecord.ingateTime || "-" }}</el-timeline-item>
          <el-timeline-item timestamp="空磅">{{ detailRecord.emptyTime || "-" }}</el-timeline-item>
          <el-timeline-item timestamp="重磅">{{ detailRecord.heavyTime || "-" }}</el-timeline-item>
          <el-timeline-item timestamp="出门">{{ detailRecord.outgateTime || "-" }}</el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getConfig,
  getSummary,
  getGroups,
  getStages,
  getPage,
  getDetail,
  getCustomerOptions,
  getCargoOptions,
} from "./api";
import { unwrapDictList } from "@/util/dict-list";

export default {
  name: "automobile-dimensional-transport",
  data() {
    return {
      filters: this.defaultFilters(),
      timeOptions: [
        { label: "重车过磅时间", value: "heavyTime" },
        { label: "出门时间", value: "outgateTime" },
        { label: "进门时间", value: "ingateTime" },
        { label: "空车过磅时间", value: "emptyTime" },
        { label: "创建时间", value: "createTime" },
      ],
      stageOptions: [
        { label: "已派未进", value: "dispatchNoIngate" },
        { label: "进门待空磅", value: "ingateNoEmpty" },
        { label: "空磅待重磅", value: "emptyNoHeavy" },
        { label: "重磅待出门", value: "heavyNoOutgate" },
        { label: "已出门完成", value: "completed" },
      ],
      dimensionTabs: [
        { label: "按客户", value: "cust", fields: ["custName"] },
        { label: "按煤种", value: "cargo", fields: ["cargoName"] },
        { label: "按计划", value: "plan", fields: ["planNo"] },
        { label: "按仓库/库位", value: "stock", fields: ["stockName", "locationName"] },
        { label: "按日期", value: "date", fields: ["heavyDate"] },
      ],
      activeDimension: "cust",
      effectiveParams: {},
      summary: {},
      groupRecords: [],
      stageRecords: [],
      tableRecords: [],
      detailRecord: null,
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      searching: false,
      stageLoading: false,
      groupLoading: false,
      tableLoading: false,
      detailLoading: false,
      detailVisible: false,
      showMoreFilters: false,
      customerLoading: false,
      cargoLoading: false,
      customerOptions: [],
      cargoOptions: [],
      defaultCustomerOptions: [],
      defaultCargoOptions: [],
      customerSearchTimer: null,
      cargoSearchTimer: null,
    };
  },
  computed: {
    summaryCards() {
      return [
        { key: "totalNetWeight", label: "实际出库量", value: this.formatWeight(this.summary.totalNetWeight), unit: "吨" },
        { key: "truckCount", label: "出库车次", value: this.summary.truckCount || 0, unit: "车" },
        { key: "inProgressTruckCount", label: "厂内进行中", value: this.summary.inProgressTruckCount || 0, unit: "车" },
        { key: "avgPlantStayMinutes", label: "平均在厂", value: this.formatNumber(this.summary.avgPlantStayMinutes), unit: "分钟" },
        { key: "heavyNoOutgate", label: "重磅待出门", value: this.getStageCount("heavyNoOutgate"), unit: "车", warning: true },
      ];
    },
    stageCards() {
      const max = Math.max.apply(null, this.stageOptions.map((item) => this.getStageCount(item.value)).concat([1]));
      return this.stageOptions.map((item) => {
        const count = this.getStageCount(item.value);
        return {
          key: item.value,
          label: item.label,
          count,
          percent: Math.min(100, Math.round((count / max) * 100)),
        };
      });
    },
    currentDimensionFields() {
      const current = this.dimensionTabs.find((item) => item.value === this.activeDimension);
      return current ? current.fields : ["custName"];
    },
  },
  async created() {
    this.loadFilterOptions();
    await this.loadConfig();
    this.handleSearch();
  },
  beforeDestroy() {
    clearTimeout(this.customerSearchTimer);
    clearTimeout(this.cargoSearchTimer);
  },
  methods: {
    defaultFilters() {
      const now = new Date();
      const startSeed = new Date(now.getTime() - 29 * 24 * 60 * 60 * 1000);
      const start = new Date(startSeed.getFullYear(), startSeed.getMonth(), startSeed.getDate(), 0, 0, 0);
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      return {
        timeType: "heavyTime",
        timeRange: [this.formatDateTime(start), this.formatDateTime(end)],
        custNo: "",
        cargoNo: "",
        planNo: "",
        trainNumber: "",
        driverName: "",
        phoneNo: "",
        stockCode: "",
        locationCode: "",
        vehicleStatus: "",
        stageCode: "",
      };
    },
    async loadConfig() {
      try {
        const res = await getConfig();
        this.effectiveParams = (res.data && res.data.data) || {};
        const defaultTimeField = this.effectiveParams.defaultTimeField || this.effectiveParams.timeField;
        if (defaultTimeField) {
          this.filters.timeType = defaultTimeField;
        }
      } catch (error) {
        this.$message.warning(this.getErrorMessage(error, "配置读取失败"));
      }
    },
    async handleSearch() {
      this.page.currentPage = 1;
      await this.loadData();
    },
    async loadData() {
      const params = this.buildParams();
      this.searching = true;
      this.stageLoading = true;
      this.groupLoading = true;
      this.tableLoading = true;
      try {
        const [summaryRes, stageRes, groupRes, pageRes] = await Promise.all([
          getSummary(params),
          getStages({ ...params, timeType: "createTime", stageCode: "" }).catch(() => ({ data: { data: { records: [] } } })),
          getGroups({ ...params, dimensionFields: this.currentDimensionFields }),
          getPage({ ...params, page: this.page.currentPage, size: this.page.pageSize }),
        ]);
        const summaryData = (summaryRes.data && summaryRes.data.data) || {};
        const stageData = (stageRes.data && stageRes.data.data) || {};
        const groupData = (groupRes.data && groupRes.data.data) || {};
        const pageData = (pageRes.data && pageRes.data.data) || {};
        const pageObj = pageData.page || {};
        this.summary = summaryData.summary || {};
        this.stageRecords = stageData.records || [];
        this.groupRecords = groupData.records || [];
        this.tableRecords = pageObj.records || [];
        this.page.total = Number(pageObj.total || 0);
        this.effectiveParams = summaryData.effectiveParams || stageData.effectiveParams || groupData.effectiveParams || pageData.effectiveParams || this.effectiveParams;
      } catch (error) {
        this.summary = {};
        this.stageRecords = [];
        this.groupRecords = [];
        this.tableRecords = [];
        this.page.total = 0;
        this.$message.error(this.getErrorMessage(error, "全维度运输查询失败"));
      } finally {
        this.searching = false;
        this.stageLoading = false;
        this.groupLoading = false;
        this.tableLoading = false;
      }
    },
    resetFilters() {
      this.filters = this.defaultFilters();
      this.activeDimension = "cust";
      this.page.currentPage = 1;
      this.handleSearch();
    },
    buildParams() {
      const range = this.filters.timeRange || [];
      return {
        businessType: 2,
        timeType: this.filters.timeType,
        startTime: range[0] || "",
        endTime: range[1] || "",
        custNo: this.filters.custNo,
        cargoNo: this.filters.cargoNo,
        planNo: this.filters.planNo,
        trainNumber: this.filters.trainNumber,
        driverName: this.filters.driverName,
        phoneNo: this.filters.phoneNo,
        stockCode: this.filters.stockCode,
        locationCode: this.filters.locationCode,
        vehicleStatus: this.filters.vehicleStatus,
        stageCode: this.filters.stageCode,
      };
    },
    loadFilterOptions() {
      Promise.all([
        this.loadCustomers(""),
        this.loadCargoes(""),
      ]).catch(() => {});
    },
    async loadCustomers(keyword = "") {
      const query = (keyword || "").trim();
      this.customerLoading = true;
      try {
        const res = await getCustomerOptions(query);
        const rows = this.normalizeOptionList(res)
          .filter((item) => item && item.id)
          .map((item) => ({
            id: item.id,
            deptName: item.deptName || item.id,
          }));
        if (!query) {
          this.defaultCustomerOptions = rows;
        }
        this.customerOptions = rows;
      } catch (error) {
        if (!query) {
          this.defaultCustomerOptions = [];
        }
        this.customerOptions = [];
      } finally {
        this.customerLoading = false;
      }
    },
    async loadCargoes(keyword = "") {
      const query = (keyword || "").trim();
      this.cargoLoading = true;
      try {
        const res = await getCargoOptions(query);
        const rows = this.normalizeOptionList(res)
          .filter((item) => item && item.varNo)
          .map((item) => ({
            varNo: item.varNo,
            varName: item.varName || item.varNo,
          }));
        if (!query) {
          this.defaultCargoOptions = rows;
        }
        this.cargoOptions = rows;
      } catch (error) {
        if (!query) {
          this.defaultCargoOptions = [];
        }
        this.cargoOptions = [];
      } finally {
        this.cargoLoading = false;
      }
    },
    filterCustomers(keyword) {
      const query = (keyword || "").trim();
      clearTimeout(this.customerSearchTimer);
      if (!query) {
        this.customerOptions = this.defaultCustomerOptions.slice();
        return;
      }
      this.customerSearchTimer = setTimeout(() => {
        this.loadCustomers(query);
      }, 300);
    },
    filterCargoes(keyword) {
      const query = (keyword || "").trim();
      clearTimeout(this.cargoSearchTimer);
      if (!query) {
        this.cargoOptions = this.defaultCargoOptions.slice();
        return;
      }
      this.cargoSearchTimer = setTimeout(() => {
        this.loadCargoes(query);
      }, 300);
    },
    normalizeOptionList(res) {
      return unwrapDictList(res);
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.loadData();
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.loadData();
    },
    handleDimensionChange() {
      this.loadData();
    },
    handleStageClick(stageCode) {
      const nextStage = this.filters.stageCode === stageCode ? "" : stageCode;
      this.filters.stageCode = nextStage;
      if (nextStage) {
        this.filters.timeType = this.getStageTimeType(nextStage);
      }
      this.handleSearch();
    },
    getStageTimeType(stageCode) {
      const mapping = {
        dispatchNoIngate: "createTime",
        ingateNoEmpty: "ingateTime",
        emptyNoHeavy: "emptyTime",
        heavyNoOutgate: "heavyTime",
        completed: "outgateTime",
      };
      return mapping[stageCode] || this.filters.timeType;
    },
    async openDetail(row) {
      this.detailVisible = true;
      this.detailRecord = row;
      if (!row || !row.id) {
        return;
      }
      this.detailLoading = true;
      try {
        const res = await getDetail(row.id);
        const data = (res.data && res.data.data) || {};
        this.detailRecord = data.detail || row;
      } finally {
        this.detailLoading = false;
      }
    },
    getStageCount(stageCode) {
      const item = this.stageRecords.find((record) => record.groupKey === stageCode);
      return item ? Number(item.truckCount || 0) : 0;
    },
    getRowStageName(row) {
      const stageCode = this.getRowStageCode(row);
      const stage = this.stageOptions.find((item) => item.value === stageCode);
      return stage ? stage.label : "-";
    },
    getRowStageCode(row) {
      if (!row) {
        return "";
      }
      if (row.outgateTime || row.vehicleStatus === 2) {
        return "completed";
      }
      if (row.heavyTime) {
        return "heavyNoOutgate";
      }
      if (row.emptyTime) {
        return "emptyNoHeavy";
      }
      if (row.ingateTime) {
        return "ingateNoEmpty";
      }
      return "dispatchNoIngate";
    },
    getStageTagType(row) {
      const stageCode = this.getRowStageCode(row);
      if (stageCode === "completed") {
        return "success";
      }
      if (stageCode === "heavyNoOutgate" || stageCode === "ingateNoEmpty") {
        return "warning";
      }
      return "info";
    },
    formatStockLocation(row) {
      const stockName = row.stockName || "-";
      const locationName = row.locationName || "-";
      return `${stockName} / ${locationName}`;
    },
    formatWeight(value) {
      const num = Number(value || 0);
      return num.toFixed(2);
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") {
        return "0";
      }
      return Number(value).toFixed(1);
    },
    formatRate(value) {
      const num = Number(value || 0);
      return `${num.toFixed(2)}%`;
    },
    formatStay(row) {
      if (row.totalDuration) {
        return row.totalDuration;
      }
      if (!row.plantStaySeconds) {
        return "-";
      }
      return `${Math.round(row.plantStaySeconds / 60)}分钟`;
    },
    formatDateTime(date) {
      const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    getErrorMessage(error, fallback) {
      return (
        (error && error.response && error.response.data && (error.response.data.msg || error.response.data.message)) ||
        (error && error.message) ||
        fallback
      );
    },
  },
};
</script>

<style scoped>
.dimension-page {
  min-height: 100%;
  padding: 12px;
  background: #f5f7fa;
}

.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-title {
  color: #202a3c;
  font-size: 18px;
  font-weight: 600;
}

.page-actions {
  display: flex;
  gap: 8px;
}

.section {
  margin-bottom: 12px;
  padding: 14px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.more-filter {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.summary-row {
  margin-bottom: 12px;
}

.metric {
  height: 88px;
  padding: 12px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.metric--warning {
  border-color: #f0c78a;
  background: #fffaf0;
}

.metric__label {
  color: #606266;
  font-size: 13px;
}

.metric__value {
  margin-top: 8px;
  color: #303133;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
}

.metric__unit {
  margin-top: 2px;
  color: #909399;
  font-size: 12px;
}

.section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #303133;
  font-weight: 600;
}

.stage-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(120px, 1fr));
  gap: 10px;
}

.stage-card {
  min-height: 66px;
  padding: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fbfcfe;
  cursor: pointer;
}

.stage-card--active {
  border-color: #409eff;
  background: #ecf5ff;
}

.stage-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #303133;
}

.stage-card__top strong {
  font-size: 20px;
}

.stage-card__bar {
  height: 6px;
  margin-top: 10px;
  overflow: hidden;
  border-radius: 3px;
  background: #e9eef5;
}

.stage-card__bar span {
  display: block;
  height: 100%;
  background: #409eff;
}

.pager {
  margin-top: 12px;
  text-align: right;
}

.detail-body {
  padding: 0 16px 16px;
}

.detail-timeline {
  margin-top: 16px;
}

@media (max-width: 1200px) {
  .stage-grid {
    grid-template-columns: repeat(3, minmax(120px, 1fr));
  }
}

@media (max-width: 768px) {
  .page-head,
  .section__head {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .stage-grid {
    grid-template-columns: 1fr;
  }
}
</style>
